import { render, staticRenderFns } from "./honor-board-list.vue?vue&type=template&id=60a68be0&scoped=true"
import script from "./honor-board-list.vue?vue&type=script&lang=js"
export * from "./honor-board-list.vue?vue&type=script&lang=js"
import style0 from "./honor-board-list.vue?vue&type=style&index=0&id=60a68be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a68be0",
  null
  
)

export default component.exports